import { Paper, Grid } from "@material-ui/core";
import {
	InputCheckboxMaster,
	InputOptionMaster,
	InputTextMaster,
	LabelRequired,
} from "App/Component/ui";
import {
	selectJamAwal,
	selectHariAkhir,
	selectHariAwal,
	selectJamAkhir,
} from "../helpers";

export default function LokasiJadwal({ formDataJadwal, setFormDataJadwal }) {
	const handleChange = (text) => (e) => {
		setFormDataJadwal({
			...formDataJadwal,
			[text]: e.target.value,
		});
	};

	return (
		<>
			<Paper className="p-1 mb-1">
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<h4>JAM OPERASI</h4>
					<InputCheckboxMaster
						checked={formDataJadwal.available}
						name="availableJadwal"
						id="availableJadwal"
						label="Punya Jam Operasi ?"
						onChange={() =>
							setFormDataJadwal({
								...formDataJadwal,
								available: !formDataJadwal.available,
							})
						}
					/>
				</div>

				<form
					onSubmit={(e) => console.log("No Method")}
					style={{
						display: formDataJadwal.available === false ? "none" : "",
					}}
				>
					<Grid container spacing={1}>
						<Grid item md={2}>
							<InputOptionMaster
								name="hari_awal"
								label={<LabelRequired label="Buka Hari" />}
								id="hari_awal"
								withSearch={false}
								data={selectHariAwal}
								value={formDataJadwal.hari_awal}
								needParse={false}
								onChange={handleChange("hari_awal")}
							/>
						</Grid>
						<Grid item md={2}>
							<InputOptionMaster
								name="hari_akhir"
								label={<LabelRequired label="Sampai Hari" />}
								id="hari_akhir"
								withSearch={false}
								data={selectHariAkhir}
								value={formDataJadwal.hari_akhir}
								needParse={false}
								onChange={handleChange("hari_akhir")}
							/>
						</Grid>
						<Grid item md={2}>
							<InputOptionMaster
								name="jam_awal"
								label={<LabelRequired label="Jam Buka" />}
								id="jam_awal"
								withSearch={false}
								data={selectJamAwal}
								value={formDataJadwal.jam_awal}
								needParse={false}
								onChange={handleChange("jam_awal")}
							/>
						</Grid>
						<Grid item md={2}>
							<InputOptionMaster
								name="jam_akhir"
								label={<LabelRequired label="Jam Tutup" />}
								id="jam_akhir"
								withSearch={false}
								data={selectJamAkhir}
								value={formDataJadwal.jam_akhir}
								needParse={false}
								onChange={handleChange("jam_akhir")}
							/>
						</Grid>
						<Grid item md={4}>
							<InputTextMaster
								name="availabilityExecptions"
								label={<LabelRequired label="Lainnya..." />}
								id="availabilityExecptions"
								placeholder="Lainnya...."
								value={formDataJadwal.availabilityExecptions}
								onChange={handleChange("availabilityExecptions")}
							/>
						</Grid>
					</Grid>
				</form>
			</Paper>
		</>
	);
}
